module.exports = __webpack_public_path__ + "img/microsite-PH.abd44288.gif";